<template>
  <div>
    <h5>Add field from <strong>Profile Form</strong> to <strong>Referral Form</strong></h5>
    <div class="row">

      <div class="col-md-9">
        <select class="form-control" v-model="selectedProfileField">
          <option :value="null"> Select field...</option>
            <option value="all-fields"> All fields</option>
          <option value="all-fields-calculations"> All fields and calculations</option>
          <option v-for="(option, oi) in profileFields"
                  :disabled="option.type === 'text-entry'"
                  :value="option"
                  v-if="option.description">
            {{ option.description | striphtml }}
          </option>
        </select>

      </div>
      <div class="col-md-3 mb-2">
        <button class="btn green" @click="addFieldFromProfile">Add</button>
      </div>
    </div>

    <hr>
  </div>
</template>

<script>
  import {mapGetters} from 'vuex';

  export default {
    name: 'ReferralAddFieldFromProfile',
    props: {
      schema: {
        type: Array,
        required: true,
      }
    },
    data() {
      return {
        selectedProfileField: null,
        profileFieldMap: {},
      }
    },
    computed: {
      ...mapGetters({
        'systemForms': "getSystemForms"
      }),
      allFields() {
        if (this.systemForms.hasOwnProperty('profile') && this.systemForms.profile.hasOwnProperty('data')) {
          return JSON.parse(this.systemForms.profile.data)
        } else {
          return [];
        }
      },
      profileFields() {
        let fields = this.allFields.filter(item => {
          return !(['row', 'divider', 'header'].includes(item.type));
        });

        let flatFields = [];

        fields.forEach(field => {
          flatFields.push(field);
          if(field.type === 'accordion') {
            field.values.forEach(fieldInAccordion => {
              flatFields.push(fieldInAccordion);
            })
          }
        });

        return flatFields
      }
    },
    methods: {
      addFieldFromProfile() {
        if (this.selectedProfileField) {
          if (typeof this.selectedProfileField === 'string') {
            this.allFields.forEach(field => this.copyField(field, false, this.schema.length));
            if (this.selectedProfileField === 'all-fields-calculations') {
              this.addConditionsAndCalculations();
            }
          } else {
            this.copyField(this.selectedProfileField);
            this.$notify('Element added!');
          }
        }
      },
      setFieldProperties(field, index) {
        field.profileFieldName = field.name;
        field.name = `${field.type}-${Date.now()}-${index}`;
        field.autoMap = !['row', 'divider', 'header', 'accordion', 'text-entry'].includes(field.type);
        // save field mapping for conditions/calculations update
        this.profileFieldMap[field.profileFieldName] = field.name;
      },
      copyField: function(item, resetFormatting=true, indexOffset=0) {
        let clonedField = JSON.parse(JSON.stringify(item));
        if (resetFormatting) {
          clonedField.grid = 12;
        }

        this.setFieldProperties(clonedField, indexOffset);
        if (clonedField.type === 'accordion') {
          Object.keys(clonedField.values).map((obj, i) => {
            this.setFieldProperties(clonedField.values[obj], indexOffset + i);
          });
        }
        this.schema.push(clonedField);
      },
      copyConditions(source) {
        return source.map(condition => {
          condition.states.forEach(state => {
            state.field = this.profileFieldMap[state.field];
            if (state.targetField) {
              state.targetField = this.profileFieldMap[state.targetField];
            }
          })
          condition.todo.forEach(todo => {
            todo.field = this.profileFieldMap[todo.field];
          })
          return condition
        })
      },
      copyCalculations(source) {
        return source.map(calculation => {
          calculation.displayIn = this.profileFieldMap[calculation.displayIn];
          calculation.questions.forEach(question => {
            if (question.field !== 'custom-value') {
              question.field = this.profileFieldMap[question.field];
            }
          });
          return calculation;
        });
      },
      copyHideValues(source) {
        return source.map(hideValue => {
          hideValue.field = this.profileFieldMap[hideValue.field];
          return hideValue;
        })
      },
      copyValidationConditions(source) {
        return source.map(validation => {
          validation.field = this.profileFieldMap[validation.field];
          validation.targetField = this.profileFieldMap[validation.targetField];
          return validation;
        })
      },
      addConditionsAndCalculations() {
        if (this.systemForms.profile) {
          const profile = this.systemForms.profile;
          this.$emit('update-form', {
            // calculations
            calculations: this.copyCalculations(JSON.parse(profile.calculations)),
            // show hide fields
            conditions: this.copyConditions(JSON.parse(profile.conditionals)),
            // hide values
            hideValues: this.copyHideValues(JSON.parse(profile.hide_values)),
            // enabled required
            validationConditions: this.copyValidationConditions(JSON.parse(profile.extra_validation_rules)),
            // update checkbox values
            updateConditions: this.copyConditions(JSON.parse(profile.update_conditionals))
          })
        }
      }
    }
  }

</script>



// WEBPACK FOOTER //
// ReferralAddFieldFromProfile.vue?7a03a8c0